export const googleMapsURL = "https://www.google.com/maps/search/?api=1&query=";

export const measurementID = 'G-LVC4CBVBKM';
export const trackingID = 'AW-16662852817';
export const clarityId = 'nmuovpuslj';

export const dynamicManifest = {
  name: ``,
  short_name: ``,
  start_url: `/`,
  display: "standalone",
  background_color: "#ffffff",
  theme_color: "#ff5722",
  icons: [
    {
      src: "/img/ios/192.png",
      sizes: "192x192",
      type: "image/png",
    },
    {
      src: "/img/ios/512.png",
      sizes: "512x512",
      type: "image/png",
    },
  ],
};

export const socialMediaDomains = [
  "facebook.com",
  "instagram.com",
  "twitter.com",
  "linkedin.com",
  "tiktok.com",
  "pinterest.com",
  "snapchat.com",
  "reddit.com",
  "youtube.com",
  "tumblr.com",
  "weibo.com",
  "vk.com",
  "ok.ru",
  "xing.com",
  "mix.com",
  "gab.com",
  "mastodon.social",
  "flickr.com",
  "deviantart.com",
  "imgur.com",
  "medium.com",
  "quora.com",
  "vimeo.com",
  "dailymotion.com",
  "twitch.tv",
  "bilibili.com",
  "discord.com",
  "slack.com",
  "whatsapp.com",
  "telegram.org",
  "signal.org",
  "clubhouse.com",
  "caffeine.tv",
  "beacons.ai",
  "substack.com",
  "onlyfans.com"
];

export const searchEngineDomains = ["google.com", "bing.com", "yahoo.com"];

export const confirmEmailTemplateId = "d-f0565683dafb493486781446ae3c7873";

export const modules = {
  CONTENT_LINKS: "module-order-content-links",
  CONTENT: 'module-order-content',
  MULTISTREAM: 'module-order-multistream',
  EVENTS: 'module-order-events',
  PRODUCTS: 'module-order-products'
}

export const TabSchema = {
  header: "header",
  theme: "theme",
  modules: {
    content: "content",
    links: "links",
    events: "events",
    multistream: "multistream",
    contact: "contact",
    products: "products"
  },
  dashboard: "dashboard",
  settings: "settings",
}

export const CurrentSymbolOptions = [{
  value: 'BRL',
  label: 'R$'
}, {
  value: 'USD',
  label: '$'
}, {
  value: 'EUR',
  label: '€',
}, {
  value: 'JPY',
  label: '¥',
}, {
  value: 'GBP',
  label: '£',
}, {
  value: 'INR',
  label: '₹',
}, {
  value: 'KRW',
  label: '₩'
}];